import { createSlice } from '@reduxjs/toolkit';

const classSlice = createSlice({
  name: 'school_classes',
  initialState: { class_id: '', class_name: '', class_data: [] },
  reducers: {
    setClasses(state, action) {
      const data = action.payload || [];
      state.class_data = data;
      if (data.length > 0) {
        state.class_id = data[0].id;
        state.class_name = data[0].naziv;
      } else {
        state.class_id = '';
        state.class_name = '';
      }
    },
    setCurrClass(state, action) {
      const { class_id, class_data } = action.payload;
      state.class_id = class_id;
      state.class_data = class_data;
      const found = class_data.find((c) => c.id == class_id);
      state.class_name = found ? found.naziv : '';
    },
    clearClasses(state) {
      state.class_id = '';
      state.class_name = '';
      state.class_data = [];
    },
  },
});

export const { setClasses, setCurrClass, clearClasses } = classSlice.actions;
export default classSlice.reducer;
